<template>
    <ModalComponent
        :name="'prueba-' + comunicado.id"
        title="Enviar prueba"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput v-if="comunicado.tipo === 1" label="Email" name="email" type="email" id="email" rules="required|email" v-model="email" />
                    <template v-else-if="comunicado.tipo === 2">
                        <label for="telefono">Teléfono</label>
                        <PhoneInput
                            name="telefono" 
                            :phone="n_telefono" 
                            :required="true"
                            :error_telefono="1"
                            @setNumber="(number) => n_telefono = number"
                            @validNumber="(valid) => isValidNumber = valid"
                        />                        
                    </template>
                </div>
                <div class="col-12 text-center mt-3">
                    <h1 class="font-weight-bold">¿ENVIAR PRUEBA?</h1>
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button">SI, ENVIAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import PhoneInput from '@/components/common/PhoneInput.vue';

    export default {
        props: ['comunicado'],
        data() {
            return {
                email: null,
                n_telefono: null,
                isValidNumber: false,
                loading: false
            }
        },
        methods: {
            close(enviado) {
                this.$emit('close', 'prueba-' + this.comunicado.id, enviado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    if (this.comunicado.tipo === 2 && ((this.n_telefono && !this.isValidNumber) || !this.n_telefono)) {
                        return;
                    }

                    this.enviar();
                }
            },
            enviar(id) {
                this.loading = true;

                const params = {
                    filters : {},
                    comunicado_id: this.comunicado.id
                }

                if (this.comunicado.tipo === 1) {
                    params.email = this.email;
                } else if (this.comunicado.tipo === 2) {
                    params.n_telefono = this.n_telefono;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.enviar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
        },
        components: {
            ModalComponent, PhoneInput
        }
    }
</script>
